import { NewContract } from '@vae/server/dist/client'
import React from 'react'
import { useTranslation } from 'react-i18next'
import RadioInput from '../../../components/inputs/RadioInput'

const BillingMethodStep: React.FC<{
	contract: Partial<NewContract>
	setContract: (key: keyof NewContract, value: string | number) => void
}> = ({ contract, setContract }) => {
	const { t } = useTranslation('modals_createContract', { keyPrefix: 'billingMethodStep' })

	return (
		<div className='container'>
			<span className='text-text-dark dark:text-white'>{t('eInvoice')}</span>
			<RadioInput
				isChecked={contract?.invoiceType === 'email'}
				onChange={() => setContract('invoiceType', 'email')}
				label={t('email')}
			/>
			<RadioInput
				isChecked={contract?.invoiceType === 'mail'}
				onChange={() => setContract('invoiceType', 'mail')}
				label={t('paper')}
			/>
		</div>
	)
}

export default BillingMethodStep
